<template>
  <div class="custom-control custom-checkbox">
    <input
      v-bind="$attrs"
      v-model="computedValue"
      class="custom-control-input"
      type="checkbox"
      :disabled="disabled"
      :false-value="falseValue"
      :id="id"
      :name="name"
      :true-value="trueValue"
      @change="onChange"
    >
    <label class="custom-control-label" :for="id">
      <slot/>
    </label>
  </div>
</template>

<script>
export default {
  created () {
    this.id = `checkbox-${this.$id.gen()}`
  },

  data () {
    return {
      id: null,
      newValue: this.value
    }
  },

  name: 'BaseCheckbox',

  props: {
    disabled: Boolean,
    name: String,
    trueValue: {
      default: true,
      type: [Boolean, Number, String]
    },
    falseValue: {
      default: false,
      type: [Boolean, Number, String]
    },
    value: [Boolean, String]
  },

  computed: {
    computedValue: {
      get () {
        return this.newValue
      },
      set (value) {
        this.newValue = value
        this.$emit('input', value)
      }
    }
  },

  watch: {
    value (value) {
      this.newValue = value
    }
  },

  methods: {
    onChange (value) {
      this.$emit('change', value)
    }
  }
}
</script>
